import React, { useState } from 'react'
import useMarketo from './Marketo'
import { inject, observer } from 'mobx-react'
import { InlineLoader } from '../../loaders'

const MarketoForm = inject('store')(observer(({ store, cta, product }) => {
  const [loaded, setLoaded] = useState(false)

  const handleSuccess = async () => {
    const res = await store.enrollExternal(
      product.id, product.partner.id,
      product.product_name, cta.id)
  }

  const r2 = /<script>[\s\S]*?<\/script>/
  const s2 = cta.marketo_form.match(r2)[0]
  const text = s2.split('<script>')[1].split('</script')[0]
  const base = text.split('(')[1].split(',')[0].replace(/"/g, '').trim()
  const mId = text.split(',')[1].split(',')[0].replace(/"/g, '').trim()
  const fId = text.split(',')[2].split(')')[0].replace(/"/g, '').trim()
  useMarketo({
    baseUrl: base,
    munchkinId: mId,
    formId: fId,
    isLoadedCallback: () => {
 setLoaded(true)
},
    successCallback: () => {
 handleSuccess()
}
  })

  if (!loaded) {
    return (
      <InlineLoader />
    )
  }

  return (
    <form id={`mktoForm_${fId}`} />
  )
}))

export default MarketoForm
